export interface HorizontalSeparatorProps {
  /** Color of the separator line */
  color?: string
  /** Width of the separator line (default: 100%) */
  width?: string | number
  /** Height of the separator line (default: 2px) */
  height?: string | number
  /** Padding around the separator */
  padding?: string | number
  /** Margin around the separator */
  margin?: string | number
  /** Additional CSS properties */
  style?: React.CSSProperties
  /** CSS class name */
  className?: string
}

export const HorizontalSeparator = ({
  color = 'var(--gray-300)',
  width = '100%',
  height = '1px',
  padding = 0,
  margin = 0,
  style,
  className,
  ...props
}: HorizontalSeparatorProps) => {
  return (
    <div
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        backgroundColor: color,
        padding: typeof padding === 'number' ? `${padding}px` : padding,
        margin: typeof margin === 'number' ? `${margin}px` : margin,
        ...style,
      }}
      className={className}
      {...props}
    />
  )
}
